import gql from "graphql-tag"
import partialUser from "@irati/identity/services/fragments/PartialUser"
import CelebrationTag from "@irati/recognition/services/fragments/CelebrationTag"
import Occasion from "@irati/recognition/services/fragments/Occasion"

const fragment = gql`
  fragment RecognitionAutomation on RecognitionAutomation {
    uuid
    message
    status
    rewardRules {
      year
      amount
    }
    createdBy {
      ...partialUser
    }
    metadata {
      createdAt
      updatedAt
      updatedBy {
        ...partialUser
      }
    }
    ruleType
    occasionId
    companyCelebrationId
    companyValueIds
    regionId
    walletId
    consent
    automationType
    senderName
    occasion {
      ...CelebrationTag
    }
    companyCelebration {
      ...Occasion
    }
    walletUser {
      ...partialUser
    }
    region {
      uuid
      teamState
      teamName
    }
    budget {
      categoryId
      categoryName
      useUnassigned
    }
    companyValues {
      results {
        archived
        name
        tag
        uuid
        icon {
          href
          alt
        }
      }
    }
  }
  ${CelebrationTag}
  ${partialUser}
  ${Occasion}
`

export default fragment
